import useUrl from './helpers/useUrl.js'
import { GAME_MODE } from '~/constants/enum'

export default (client, { $formFactor, $language }) => {
  const v4 = useUrl('v4/games')
  const version = $formFactor()
  const language = $language()

  return {
    getGame({ isLoggedIn, term }) {
      const url = v4(`${isLoggedIn ? GAME_MODE.PLAY : GAME_MODE.DEMO}`)

      const params = {
        term,
        version,
        language,
        check_limits: 1,
      }
    
      return client.get(url, { params })
    },
  }
}
